export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/fbf1cfaf74329f9a6a1fed67972e7c52.svg";